import { createStore, applyMiddleware, compose } from "redux";
import reducer from "../reducers/reducer";
import promiseMiddleware from "./promiseMiddleware";

const middlewares = [promiseMiddleware];

const store = createStore(reducer, compose(applyMiddleware(...middlewares)));
export default store;
